import moment from 'moment';

export function addCke(name, value, expiryDate = null) {
  if (typeof document !== 'undefined') {
    let expires = '';
    if (expiryDate) {
      // const date = new Date();
      // date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = `; expires=${new Date(expiryDate).toGMTString()}`;
    }
    const cookie = [
      name,
      '=',
      value,
      '; domain_.',
      window.location.host.toString(),
      expires,
      '; path=/;'
    ].join('');
    document.cookie = cookie;
  }
}

export function getCke(name) {
  let result = null;
  if (typeof document !== 'undefined') {
    result = document.cookie.match(new RegExp(`${name}=([^;]+)`));
    result = result != null ? result[1] : result;
  }
  return result;
}

export function delAllCke() {
  if (typeof document !== 'undefined') {
    document.cookie.split(';').forEach((c) => {
      document.cookie = c
        .replace(/^ +/, '')
        .replace(/=.*/, `=;expires=${new Date(moment().subtract(1, 'days')).toUTCString()};path=/`);
    });
  }
}
